import React, { useContext } from "react";
import { Switcher } from "../view/Switcher";
import * as deviceService from "../devices/deviceService";
import { deepCopy } from "../utils";
import { TableContext } from "../index";

function DeviceManagementTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);

    const onEnableAlertClick = (value) => {
        const device = deepCopy(data);
        device.enableAlerting = value;
        deviceService.patch(device)
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }));
    }

    return (
        <tr key={index}>
            <td>
                {data.hostName}
            </td>
            <td className="w-100">
                <div>
                    <div className="custom-control custom-switch">
                        <Switcher value={data.enableAlerting} onClick={onEnableAlertClick} />
                    </div>
                </div>
            </td>
        </tr>
    )


}

export default DeviceManagementTableRow;